export const testimonials = [
  {
    name: 'Sarah Mitchell',
    username: 'sarahm_joplin',
    rating: 5,
    review: 'Burtman\'s team did an amazing job painting our home exterior. They were professional, punctual, and the quality is outstanding. Our house looks brand new!'
  },
  {
    name: 'Michael Thompson',
    username: 'mikethompson',
    rating: 4,
    review: 'We\'ve been using their lawn maintenance service for two years now. Our yard has never looked better. Highly recommend their weekly service!'
  },
  {
    name: 'Jennifer Davis',
    username: 'jendavis_mo',
    rating: 5,
    review: 'The interior painting job exceeded our expectations. They helped us choose the perfect colors and finished ahead of schedule. Very impressed!'
  },
  {
    name: 'Robert Johnson',
    username: 'robjohnson',
    rating: 5,
    review: 'Professional landscaping service that transformed our backyard into an oasis. The design was creative and the installation was flawless.'
  },
  {
    name: 'Emily Rodriguez',
    username: 'emilyrod',
    rating: 4,
    review: 'They installed beautiful rock landscaping around our home and planted gorgeous flowers. The attention to detail was impressive and our curb appeal has never been better!'
  },
  {
    name: 'David Chen',
    username: 'davidchen_mo',
    rating: 5,
    review: 'Best painting contractor in Missouri! They painted our entire house interior and it looks magazine-worthy. Fair pricing and excellent work.'
  }
];
